export default function CollapseIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="collapse-icon"
      aria-hidden="true"
      role="img"
      width={width ? width : height ? height : 17}
      height={height ? height : width ? width : 17}
      viewBox="0 0 16 16"
    >
      <path
        d="M2.667,16A2.666,2.666,0,0,1,0,13.334V2.667A2.667,2.667,0,0,1,2.667,0H13.334A2.666,2.666,0,0,1,16,2.667V13.334A2.666,2.666,0,0,1,13.334,16Zm10.667-1.333a1.335,1.335,0,0,0,1.333-1.333V2.667a1.335,1.335,0,0,0-1.333-1.333H6.267V14.667Zm-12-12V13.334a1.335,1.335,0,0,0,1.333,1.333H4.933V1.333H2.667A1.335,1.335,0,0,0,1.333,2.667Zm8.254,7.757-1.992-2a.7.7,0,0,1-.136-.192.536.536,0,0,1,0-.464A.674.674,0,0,1,7.6,7.573L9.578,5.581a.565.565,0,0,1,.412-.175h.017a.621.621,0,0,1,.417.171l.007.007a.628.628,0,0,1,.171.422.556.556,0,0,1-.164.423l-.972.963h3.466a.6.6,0,1,1,0,1.208H9.463l.984.984a.549.549,0,0,1,.164.418.623.623,0,0,1-.171.418l-.007.007a.6.6,0,0,1-.426.166A.573.573,0,0,1,9.588,10.424Z"
        fill="currentColor"
      />
    </svg>
    // <svg
    //   className="collapse-icon"
    //   aria-hidden="true"
    //   role="img"
    //   xmlns="http://www.w3.org/2000/svg"
    //   width={width ? width : height ? height : 20}
    //   height={height ? height : width ? width : 20}
    //   viewBox="0 0 48 48"
    //   // width={width ? width : height ? height * (448 / 512) : 448}
    //   // height={height ? height : width ? width * (512 / 448) : 512}
    //   // viewBox="0 0 448 512"
    // >
    //   <path
    //     fill="currentColor"
    //     d="m32.9 35.1-9.55-9.55q-.3-.3-.45-.65-.15-.35-.15-.75t.15-.75q.15-.35.45-.65l9.6-9.6q.6-.6 1.425-.6.825 0 1.425.6.6.6.6 1.425 0 .825-.6 1.425l-8.15 8.15 8.15 8.15q.6.6.6 1.4 0 .8-.6 1.4-.6.6-1.45.6t-1.45-.6Zm-19.4 1.6q-.85 0-1.425-.575-.575-.575-.575-1.425V13.3q0-.85.575-1.425.575-.575 1.425-.575.85 0 1.425.575.575.575.575 1.425v21.4q0 .85-.575 1.425-.575.575-1.425.575Z"
    //   />
    //   {/* <path
    //     fill="currentColor"
    //     d="M216 412.5l-148.5-148c-4.7-4.7-4.7-12.3 0-17L216 99.5c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L124.1 239H436c6.6 0 12 5.4 12 12v10c0 6.6-5.4 12-12 12H124.1L240 388.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.6 4.7-12.2 4.7-16.9 0zM12 448h8c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12h-8C5.4 64 0 69.4 0 76v360c0 6.6 5.4 12 12 12z"
    //   /> */}
    // </svg>
  );
}
